import type { VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'solid-js'
import { cva } from 'class-variance-authority'
import { splitProps } from 'solid-js'
import { cn } from '../../utils/cn.ts'

export const badgeVariants = cva(
  'inline-flex shrink-0 items-center justify-center overflow-hidden whitespace-nowrap border border-transparent text-xs font-medium transition-all focus-visible:(border-ring ring-[3px] ring-ring/50)',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground',
        secondary: 'bg-secondary text-secondary-foreground',
        destructive: 'bg-destructive/10 text-destructive dark:bg-destructive/20',
        outline: 'border-border text-foreground',
      },
      size: {
        default: 'h-5 rounded-full px-2 py-0.5',
        sm: 'rounded-full px-1.5 h-4 text-2xs',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export function Badge(props: ComponentProps<'div'> & VariantProps<typeof badgeVariants>) {
  const [local, rest] = splitProps(props, ['class', 'variant', 'size'])

  return (
    <div
      class={cn(
        badgeVariants({
          variant: local.variant,
          size: local.size,
        }),
        local.class,
      )}
      {...rest}
    />
  )
}
